import React from 'react';
import Navigation from './Navigation';
import Footer from './Footer';
import SEO from '../../components/SEO';
const Layout = props => {
  const {
    children,
    data
  } = props;
  //   todo get the logo via the data. If no logo via the data || some condition passes, then get it from local.
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SEO, {
    data: data
  }), /*#__PURE__*/React.createElement(Navigation, {
    data: data
  }), children, /*#__PURE__*/React.createElement(Footer, {
    data: data
  }));
};
export default Layout;